<template>
  <div class="body">
    <div class="logo_header">
      <div class="logo">
        <!-- <img src="../../assets/logo.png" style="height: 80px;" alt="" /> -->
      </div>
    </div>
    <div class="login-banner" v-loading="loading" element-loading-text="登录中，请稍后"
      element-loading-background="rgba(0, 0, 0, 0.5)">
      <div class="container">
        <div id="alert" style="background: transparent" v-show="wxShow === false && companyWxShow === false"></div>

        <div id="alert" v-show="wxShow">
          <div id="login_container" ref="login_container"></div>
        </div>

        <div id="alert" v-show="companyWxShow">
          <div id="company_login_container" ref="company_login_container" v-show="companyWxShow"></div>
        </div>

        <div class="login-box">
          <!-- <span class="login_method" @click="showCompany = !showCompany">
            {{ showCompany ? "微信扫码登录 ->" : "企业微信扫码登录 ->" }}
          </span> -->
          <div class="login-tab">
            <ul>
              <li :class="{ active: active == index }" v-for="(item, index) in tabList" :key="index"
                @click="tabClick(index)">
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="tab-pane" v-show="active == 0">
            <div class="login_form">
              <div class="iconfontBox">
                <img src="../../assets/icon-user.png" />
              </div>
              <input autofocus="autofocus" class="login_input" name="userName" type="text" value v-model="loginName"
                placeholder="公共/个人账号" />
            </div>
            <div class="login_form">
              <div class="iconfontBox">
                <img src="../../assets/icon-pwd.png" />
              </div>
              <input class="login_input" name="passWord" ref="pwd" type="password" @keyup.enter="loginClick" value
                v-model="password" placeholder="密码" />
              <div class="sc">
                <!-- <i class="el-icon-view" @click="handleChangeType"></i> -->
                <img class="sc_eye" v-if="showEye" src="../../assets/eye.png" alt="" @click="handleChangeType" />
                <img class="sc_eye" v-else src="../../assets/eye-close.png" alt="" @click="handleChangeType" />
              </div>
            </div>
            <div class="automatic">
              <el-checkbox v-model="automaticchecked">七天自动登录</el-checkbox>
            </div>
            <div class="login_btn" @click="loginClick">登&nbsp;&nbsp;录</div>

            <div class="code_btn">
              <img class="code_img" src="../../assets/wx.svg" @click="
                companyWxShow = false;
              wxShow = !wxShow;
              " />
              <!-- <img
                class="code_img"
                src="../../assets/qywx.svg"
                @click="
                  wxShow = false;
                  companyWxShow = !companyWxShow;
                "
              /> -->
              <span style="color: #fff">微信扫码登录</span>
            </div>

            <!-- <div class="login_btn_register" @click="register">注&nbsp;&nbsp;册</div> -->
          </div>
          <div class="tab-pane" v-show="active == 1">
            <div class="login_form">
              <div class="iconfontBox">
                <!-- <span class="iconfont icon-shoujihao"></span> -->
                <img src="../../assets/icon-phone.png" />
              </div>
              <input autofocus="autofocus" class="login_input" name="userName" type="text" value v-model="phone"
                placeholder="手机号码" />
            </div>
            <div class="login_form">
              <div class="iconfontBox">
                <!-- <span class="iconfont icon-yanzhengma1"></span> -->
                <img src="../../assets/icon-pwd.png" />
              </div>
              <span id="smsbtn" class="btn-code" v-show="!identifying" @click="sendSMS">获取验证码</span>
              <span id="smsbtn" class="btn-code active" v-show="identifying">{{ SMSCode }}秒后重新获取</span>
              <input class="login_input" type="text" @keyup.enter="ificationLogin" value v-model="verificationCode"
                placeholder="验证码" />
            </div>
            <div class="login_btn" @click="ificationLogin">
              登&nbsp;&nbsp;录
            </div>

            <div class="code_btn">
              <img class="code_img" src="../../assets/wx.svg" @click="
                companyWxShow = false;
              wxShow = !wxShow;
              " />
              <!-- <img
                class="code_img"
                src="../../assets/qywx.svg"
                @click="
                  wxShow = false;
                  companyWxShow = !companyWxShow;
                "
              /> -->
              <span style="color: #fff">微信扫码登录</span>
            </div>

            <!-- <div class="login_btn_register" @click="register">注&nbsp;&nbsp;册</div> -->
          </div>
          <div class="tab-pane" v-show="active == 2"></div>
          <!-- <div
            class="viewCode"
            style="padding-bottom: 5px;fontSize:12px"
          >系统使用浏览器要求：谷歌浏览器、火狐浏览器、360极速浏览器</div>-->
          <p class="login_p" v-show="active < 2">欢迎使用卫创平台</p>
        </div>
      </div>
    </div>
    <div class="footer">
      版权所有 卫创平台
      <el-link type="success" href="https://beian.miit.gov.cn" target="_blank">鄂ICP备2024084485号-2</el-link>
      <br />
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      automaticchecked: JSON.parse(localStorage.getItem("usnstate")) || false,
      appid: "", //微信二维码所需
      openid: "",
      qyAppid: "",
      qyOpenid: "",
      redirectUri: "",
      loginName: localStorage.getItem("usn") || "",
      password: localStorage.getItem("pdw") || "",
      tabList: ["账号登录"],
      active: 0,
      phone: "",
      identifying: false,
      SMSCode: 60,
      verificationCode: "",
      SMSkey: "",
      loading: false,
      showCompany: false,
      wxShow: false,
      companyWxShow: false,
      showEye: false,
    };
  },
  created() {
    this.ipLogin();
    if (localStorage.getItem("autoKey")) {
      this.handleAutoLogin();
    }
    this.$api.wechatInfo().then((res) => {
      if (res.data.code == 200) {
        this.appid = res.data.data.appid;
        this.redirectUri = res.data.data.redirectUri;
        this.qyAppid = res.data.data.qyAppid;
        this.wxReload();
        this.companyWeChatScan();
      } else {
        this.$message.error(res.data.message);
      }
    });
    if (this.$route.query.appId) {
      sessionStorage.setItem("appidSys", this.$route.query.appId);
    }
    if (this.$route.query.code == 3081) {
      this.$alert("首次使用微信登录，请使用手机登录进行绑定", "提示", {
        confirmButtonText: "确定",
      });
      this.tabList = ["账号登录", "手机登录"];
      this.active = 1;
      this.qyOpenid = this.$route.query.message;
    }
    if (this.$route.query.code == 308) {
      this.$alert("首次使用微信登录，请使用手机登录进行绑定", "提示", {
        confirmButtonText: "确定",
      });
      this.tabList = ["账号登录", "手机登录"];
      this.active = 1;
      this.openid = this.$route.query.message;
      // sessionStorage.setItem("openId", this.$route.query.message);
    } else if (this.$route.query.code == 304) {
      this.$alert('"微信扫描登录失败,请使用其他方式登录', "提示", {
        confirmButtonText: "确定",
      });
      this.active = 0;
    }
    // let query = location.href.split("?");
    // if (query.length == 2) {
    //   let arr = query[1].split("&");
    //   this.loginName = arr[0].split("=")[1];
    //   this.password = arr[1].split("=")[1];
    //   this.loginClick();
    // }
  },
  methods: {
    register() {
      this.$router.push("/register");
    },
    handleChangeType() {
      if (this.$refs.pwd.type === "password") {
        this.showEye = true;
        this.$refs.pwd.type = "input";
      } else {
        this.showEye = false;
        this.$refs.pwd.type = "password";
      }
    },
    //ip登录
    ipLogin() {
      this.loading = true;
      this.$api
        .ssoLogin({
          type: "IP",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else if (res.data.code == 309) {
            this.loading = false;
            return;
          } else {
            this.loading = false;
            this.$message.error(res.data.message);
          }
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    //用户名密码登录
    loginClick() {
      this.loading = true;
      this.$api
        .ssoLogin({
          username: this.loginName,
          password: this.password,
          appId: sessionStorage.getItem("appidSys"),
          type: "USERNAME",
          // todo
          autoLogin: this.automaticchecked ? true : false,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            const { aid, dcode, realName, username } = res.data.data;
            const targetStrings = [
              "book_shanxi",
              "bookmed4",
              "book_med2",
              "book_hubei",
              "book_med",
            ];
            // 使用 findIndex 方法在 targetStrings 数组中查找满足条件的元素的索引
            const foundIndex = targetStrings.findIndex((target) =>
              aid.includes(target)
            );
            if (foundIndex !== -1) {
              stat(dcode, 1, realName, username);
            }
            localStorage.setItem("uname", this.loginName);
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else {
            this.$message.error(res.data.message);
          }
          if (this.automaticchecked == true) {
            localStorage.setItem("usn", this.loginName);
            localStorage.setItem("pdw", this.password);
            localStorage.setItem("autoKey", res.data.data.autoKey);
            localStorage.setItem(
              "usnstate",
              JSON.stringify(this.automaticchecked)
            );
          } else {
            if (localStorage.getItem("usn")) {
              localStorage.removeItem("usn");
              localStorage.removeItem("pdw");
              localStorage.removeItem("usnstate");
              localStorage.removeItem("autoKey");
            }
          }
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    tabClick(index) {
      this.active = index;
      if (index == 2) {
        this.wxReload();
      }
    },
    wxReload() {
      var obj = new WxLogin({
        id: "login_container", //div的id
        appid: this.appid,
        scope: "snsapi_login", //写死
        redirect_uri: this.redirectUri,
        state: sessionStorage.getItem("appidSys"),
        style: "black", //二维码黑白风格
        href:
          "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDI0MHB4O2NvbG9yOiNkZGR9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ0K",
      });
    },
    companyWeChatScan() {
      // 初始化
      this.wwLogin = ww.createWWLoginPanel({
        el: "#company_login_container",
        params: {
          login_type: "ServiceApp",
          appid: this.qyAppid,
          redirect_uri: "https://www.medbooks.com.cn/#/wwLogin",
          state: "loginState",
          style: "black", //二维码黑白风格
          panel_size: "small",
        },
      });
      this.wwLogin.el.style = "width: 235px; height: 362px;";
    },
    sendSMS() {
      var reg = /^1[0-9]{10}$/;
      var flag = reg.test(this.phone);
      if (!flag) {
        this.$message.error("请输入正确手机号!");
        return;
      }
      let obj = {
        phone: this.phone,
      };
      this.$api.code(obj).then((res) => {
        if (res.data.code == 200) {
          this.identifying = true;
          this.SMSCode = 60;
          var Interval = setInterval(() => {
            this.SMSCode = this.SMSCode - 1;
            if (this.SMSCode == 0) {
              this.identifying = false;
              clearInterval(Interval);
            }
          }, 1000);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    ificationLogin() {
      this.loading = true;
      this.$api
        .ssoLogin({
          phone: this.phone,
          appId: sessionStorage.getItem("appidSys"),
          code: this.verificationCode,
          openid: this.openid,
          qyOpenid: this.qyOpenid,
          type: "TELPHONE",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    handleAutoLogin() {
      this.loading = true;
      this.$api
        .autoLogin({
          autoKey: localStorage.getItem("autoKey"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else if (res.data.code == 309) {
            this.loading = false;
            return;
          } else {
            this.loading = false;
            // this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 800px) {

  .footer,
  .logo_header,
  .login-banner {
    width: 900px !important;
  }

  .container {
    width: 900px !important;
    font-size: 10px;
  }
}

@media (min-width: 800px) and (max-width: 991px) {
  .container {
    width: 800px !important;
    font-size: 10px;
  }

  #alert {
    width: 230px !important;
    height: 363px !important;
  }

  #alert> ::v-deep .el-divider__text,
  .el-link {
    font-size: 10px;
  }

  .container .login_form {
    margin: 5px 0;
  }

  .container .login-box {
    margin-left: 10px;
  }

  .container .login-box,
  .container .login_p {
    margin-left: 20px;
    padding: 0;
  }

  .container .login_p {
    top: 160px;
  }

  .container .login-box {
    width: 250px;
    height: 200px !important;
  }

  .container .login-tab ul li {
    font-size: 14px;
  }

  .container .login_input,
  .container .login_btn {
    width: 220px !important;
  }

  .btn-code {
    left: 120px !important;
  }
}

@media (min-width: 992px) and (max-width: 1265px) {
  .container {
    width: 990px !important;
    font-size: 14px;
  }

  .container .login-box {
    margin-left: 20px;
  }
}

@media (min-width: 1266px) and (max-width: 1550px) {
  .container {
    font-size: 14px;
  }
}

@media (min-width: 1550px) {
  .container {
    font-size: 16px;
  }
}

.sc {
  position: absolute;
  right: 20px;
  top: 25%;
  font-size: 1.3rem;
  cursor: pointer;
}

.sc_eye {
  width: 20px;
}

#alert {
  position: relative;
  top: 125px;
  width: 300px;
  height: 330px;
  padding: 10px;
  box-sizing: border-box;
  color: #eee;
  border-radius: 4px;
  flex-shrink: 1;
  background: #fff;
  margin-right: 10px;
}

#alert>h3 {
  text-align: center;
}

#login_container {
  position: relative;
  flex-shrink: 1;
  width: 235px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
  background: #fff;
  height: 353px;
  overflow: hidden;
}

#login_container::before {
  content: "微信扫码登录";
  display: block;
  width: 160px;
  margin: 0 auto;
  text-align: center;
  color: #333;
  padding: 40px 0px 35px;
  font-size: 18px;
  line-height: 20px;
}

#company_login_container {
  display: block;
  position: relative;
  flex-shrink: 1;
  width: 235px;
  border: 5px;
  overflow: hidden;
  height: 362px;
}

#company_login_container::before {
  content: "";
  display: block;
  width: 160px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: 20px;
}

.logo_header {
  height: 80px;
  background: #00ab71;
  position: relative;
}

.logo {
  /* background: url(../../assets/logo.png) no-repeat; */
  /* height: 180px;
  width: 268px; */
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -134px;
  z-index: 2;
}

.login-banner {
  height: 590px;
  background: url(../../assets/img/login-banner-bg.jpg) no-repeat center center;
}

.container {
  position: relative;
  margin: 0 auto;
  padding-bottom: 100px;
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  overflow: hidden;
  padding-right: 200px;
}

.login-box {
  width: 350px;
  height: 353px;
  padding: 10px 40px 30px;
  border-radius: 5px;
  border-top-left-radius: 0;
  position: relative;
  top: 170px;
  background: url(../../assets/bg-login-box.png) repeat;
  flex-shrink: 1;
}

.login-tab ul {
  position: absolute;
  top: -44px;
  left: 0;
}

.login-tab ul li {
  float: left;
  width: 111px;
  height: 44px;
  font-size: 18px;
  text-align: center;
  color: #fff;
  line-height: 44px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-right: 5px;
  cursor: pointer;
  background: url(../../assets/bg-login-tab.png) repeat;
}

.login-tab ul li.active {
  background: url(../../assets/bg-login-box.png) repeat;
  color: #00ab71;
}

.login_form {
  position: relative;
  height: 44px;
  width: 280px;
  margin: 10px 0;
}

.login_form .iconfontBox {
  width: 42px;
  height: 40px;
  border: 1px solid #ccc;
  display: inline-block;
  position: absolute;
  left: 0;
  cursor: default;
  text-align: center;
  line-height: 40px;
}

.login_form .iconfontBox img {
  vertical-align: middle;
}

.login_form .iconfontBox .iconfont {
  font-size: 20px;
}

.btn-code {
  position: absolute;
  left: 170px;
  *top: 1px;
  height: 41px;
  width: 100px;
  display: inline-block;
  background: #ccc;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
}

.btn-code.active,
.btn-code:hover {
  background: #00ab71;
  color: #fff;
}

.icon-users {
  background: url(../../assets/icon-user.png) no-repeat center 10px;
  width: 42px;
  height: 42px;
  border: 1px solid #ccc;
  display: inline-block;
  position: absolute;
  left: 0;
  cursor: default;
}

.icon-pwd {
  background: url(../../assets/icon-pwd.png) no-repeat center 10px;
  width: 42px;
  height: 42px;
  border: 1px solid #ccc;
  display: inline-block;
  position: absolute;
  left: 0;
  cursor: default;
}

.login_input {
  width: 270px;
  padding: 10px 0 10px 50px;
  border: 1px solid #ccc;
  background: #fff;
  font-family: "microsoft yahei", sans-serif;
  font-size: 14px;
  color: #333;
}

.login_btn {
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  margin-bottom: 10px;
  background: #00ab71;
  border: 1px solid #00ab71;
  line-height: 44px;
}

.code_btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.code_img {
  width: 30px;
  margin-right: 10px;
  cursor: pointer;
}

.login_btn:hover {
  background: #14be82;
}

.login_btn_register {
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  margin-bottom: 10px;
  background: #b37e2f;
  border: 1px solid #b37e2f;
  line-height: 44px;
}

.login_btn_register:hover {
  background: #d3973e;
}

.login_p {
  position: absolute;
  top: 245px;
  margin-left: 50px;
  font-size: 16px;
  color: #fff;
}

.third_login {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}

.footer {
  text-align: center;
  margin: 10px 0;
  color: #999;
  line-height: 24px;
  font-size: 14px;
}

.automatic {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.automatic /deep/ .el-checkbox .el-checkbox__label {
  color: #fff;
}

.automatic /deep/ .is-checked .el-checkbox__input .el-checkbox__inner {
  background: #00ab71;
  border: none;
}

.automatic /deep/ .is-checked .el-checkbox__input .el-checkbox__inner::after {
  left: 5px;
  top: 2px;
}

.automatic /deep/ .is-checked .is-focus {
  border: none;
}

::v-deep .wwLogin_qrcode_head {
  display: none;
}

.login_method {
  position: absolute;
  top: -61px;
  right: -148px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
  display: inline-block;
  width: 130px;
  color: #00ab71;
  z-index: 9999;
}

.login_method:hover {
  color: #00ab71;
}
</style>
